import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button, CircularProgress, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../../services/authService';

const WelcomeCompleteScreen: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGoToDashboard = async () => {
    setLoading(true);
    setError('');
    try {
      await authService.completeOnboarding(); // Mettre à jour le statut onboard à "yes"
      navigate('/dashboard');
    } catch (err: any) {
      console.error('Erreur lors de la finalisation de l\'onboarding:', err);
      setError(err.message || t('onb.complete.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#000000',
        p: { xs: 3, md: 4 },
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '550px',
          p: { xs: 4, md: 8 },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: '#000000',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
        }}
      >
        <Typography variant="h4" sx={{ mb: 2, color: '#fff', textAlign: 'center' }}>
          {t('onb.complete.title')}
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'rgba(255,255,255,0.7)', textAlign: 'center' }}>
          {t('onb.complete.subtitle')}
        </Typography>
        {error && (
          <Alert
            severity="error"
            sx={{
              mb: 2,
              backgroundColor: 'rgba(244, 67, 54, 0.1)',
              border: '1px solid rgba(244, 67, 54, 0.3)',
              color: '#ff6b6b',
            }}
          >
            {error}
          </Alert>
        )}
        <Button
          fullWidth
          variant="contained"
          onClick={handleGoToDashboard}
          disabled={loading}
          sx={{
            height: '56px',
            borderRadius: '8px',
            backgroundColor: '#f1c086',
            '&:hover': {
              backgroundColor: '#e0b076',
            },
            color: '#000',
            fontSize: '1rem',
            fontWeight: 'bold',
          }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : t('onb.complete.goToDashboard')}
        </Button>
      </Box>
    </Box>
  );
};

export default WelcomeCompleteScreen; 